module.exports = __webpack_public_path__ + "img/itss.bd4a5f4b.png";